import { render, staticRenderFns } from "./BasicFields.vue?vue&type=template&id=a903b6ce"
import script from "./BasicFields.vue?vue&type=script&lang=js"
export * from "./BasicFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports